@if (catalogInfo) {
	<address class="d-flex flex-column bg-gray-300 p-4 contact-wrapper">
		<span class="title fw-bold text-larger">{{ catalogInfo.manufacturerName }}</span>
		<div class="mt-4">
			<lib-button variant="primary" (clicked)="openContactForm()" tooltip="{{ 'global.contactform' | translate }}">
				<img
					src="assets/material/actionbuttons/ic_mail_outline_24px.svg"
					class="me-2"
					loading="lazy"
					alt="Kontaktformular"
					width="24px"
					height="24px" />
				<span>{{ 'global.contact' | translate }}</span>
			</lib-button>
		</div>
		<div class="d-flex flex-column mt-4">
			@if (catalogInfo.streetAndNumber || catalogInfo.countryZipAndCity) {
				<div class="d-flex mt-1 align-items-start">
					<div class="me-3">
						<img src="assets/orca/contact-info/room.svg" loading="lazy" alt="Adresse" width="20px" height="20px" />
					</div>
					@if (catalogInfo.streetAndNumber || catalogInfo.countryZipAndCity) {
						<div class="d-flex flex-column">
							@if (catalogInfo.streetAndNumber) {
								<div class="text-break">
									{{ catalogInfo.streetAndNumber }}
								</div>
							}
							@if (catalogInfo.countryZipAndCity) {
								<div class="text-break">
									{{ catalogInfo.countryZipAndCity }}
								</div>
							}
						</div>
					}
				</div>
			}
			<div class="mt-2">
				@if (catalogInfo.phone) {
					<div class="d-flex align-items-center">
						<div class="me-3">
							<img src="assets/orca/contact-info/call.svg" loading="lazy" alt="Telefon" width="20px" height="20px" />
						</div>
						@if (catalogInfo.phone) {
							<div class="d-flex flex-column">
								<div class="text-break">
									{{ catalogInfo.phone }}
								</div>
							</div>
						}
					</div>
				}
				@if (catalogInfo.fax) {
					<div class="d-flex align-items-center">
						<div class="me-3">
							<img src="assets/orca/contact-info/print.svg" loading="lazy" alt="Fax" width="20px" height="20px" />
						</div>
						<div class="d-flex flex-column">
							<div class="text-break">
								{{ catalogInfo.fax }}
							</div>
						</div>
					</div>
				}
			</div>
			<div class="mt-2">
				<div class="d-flex flex-column">
					@if (catalogInfo.email1 || catalogInfo.email2) {
						<div class="d-flex align-items-start">
							<div class="me-3">
								<img
									src="assets/orca/contact-info/ic_mail_outline.svg"
									loading="lazy"
									alt="Mail"
									width="18px"
									height="18px" />
							</div>
							@if (catalogInfo.email1 || catalogInfo.email2) {
								<div class="d-flex flex-column">
									@if (catalogInfo.email1) {
										<div>
											<span
												tabindex="0"
												(click)="openContactForm()"
												(keyup.enter)="openContactForm()"
												class="app-link-dark text-break line-height-medium"
												href="">
												{{ catalogInfo.email1 }}
											</span>
										</div>
									}
									@if (catalogInfo.email2) {
										<div>
											<a
												class="app-link-dark text-break line-height-medium"
												href="mailto://{{ catalogInfo.email2 }}"
												(click)="trackWebEmailEvent(catalogExternalViewType.Email2, catalogInfo.email2)">
												{{ catalogInfo.email2 }}
											</a>
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
				<div class="d-flex flex-column">
					@if (catalogInfo.webSite1 || catalogInfo.webSite2) {
						<div class="d-flex align-items-start">
							<div class="me-3">
								<img src="assets/orca/contact-info/language.svg" alt="Website" width="18px" height="18px" />
							</div>
							@if (catalogInfo.webSite1 || catalogInfo.webSite2) {
								<div class="d-flex flex-column">
									@if (catalogInfo.webSite1) {
										<div>
											<a
												class="app-link-dark text-break line-height-medium"
												[href]="getLink(catalogInfo.webSite1)"
												target="_blank"
												rel="noreferrer"
												(click)="
													trackWebEmailEvent(catalogExternalViewType.WebSite1, getLink(catalogInfo.webSite1))
												">
												{{ catalogInfo.webSite1 }}
											</a>
										</div>
									}
									@if (catalogInfo.webSite2) {
										<div>
											<a
												class="app-link-dark text-break line-height-medium"
												[href]="getLink(catalogInfo.webSite2)"
												target="_blank"
												rel="noreferrer"
												(click)="
													trackWebEmailEvent(catalogExternalViewType.WebSite2, getLink(catalogInfo.webSite2))
												">
												{{ catalogInfo.webSite2 }}
											</a>
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
			</div>
		</div>
		@if (catalogInfo.socialMedia?.length) {
			<div class="d-flex mt-4">
				@for (socialMedia of catalogInfo.socialMedia; track socialMedia) {
					<div class="me-2 mb-2">
						<a
							[href]="getLink(socialMedia.domain)"
							target="_blank"
							class="colored-on-hover d-inline-block"
							rel="noreferrer"
							(click)="trackSocialMediaEvent(socialMedia.socialMediaType, getLink(socialMedia.domain))">
							<img
								class="social-media-logo"
								loading="lazy"
								style="height: 1.8rem; width: 1.8rem"
								[alt]="socialMediaType[socialMedia.socialMediaType]"
								[src]="getSocialMediaLogo(socialMedia.socialMediaType)" />
						</a>
					</div>
				}
			</div>
		}
	</address>
}
